<template>
    <f7-page color-theme="teal" name="editevent" >
        <f7-navbar title="Edit event">
            <f7-nav-right>
                <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="right"></f7-link>
            </f7-nav-right>
        </f7-navbar>
    <f7-list no-hairlines-md form>

        <f7-list-input
                label="Jobgroup"
                type="select"
                :value="todoFilter.jobgroupID"
                @input="todoFilter.jobgroupID = $event.target.value"
                :required="true"
                :validate="true"
        >
            <option value="">Please select a Job Group</option>
            <option v-for="(jobgroup) in jobgroup" :key="jobgroup.ID"
                    :value="jobgroup.ID" >{{ jobgroup.description }}</option>
        </f7-list-input>

        <f7-list-input
            label="Date"
            type="date"
            :value="todoFilter.date"
            @input="todoFilter.date = $event.target.value"
            :required="true"
            :validate="true"
        >
        </f7-list-input>

        <f7-block>
            <f7-row tag="p">
                <f7-col tag="span">
                    <f7-button raised big fill  @click.prevent="searchEvent" color-theme="teal">
                        Get events for day
                    </f7-button>
                </f7-col>
            </f7-row>
        </f7-block>
    </f7-list>
    </f7-page>
</template>

<script>
    export default {
        data() {
            return {
                tokenValue: {},
                token: localStorage.getItem('token'),
                user: {},
                todoFilter: {
                    date: new Date().toISOString().substr(0,10),
                    jobgroupID: '',
                },
                errors: {}
            }
        },
        watch: {
            isAuth(val) {
                if(val==false) {
                    this.$f7router.navigate('/login');
                }
            }
        },
        computed:{
            isAuth() {
                return this.$store.getters['admin/isAuth']
            },
            jobgroup() {
                return this.$store.getters['jobgroup/getJobGroup']
            }
        },
        methods: {
            getJobGroup() {
                this.tokenValue = this.$parseJWT(this.token);
                this.$store.dispatch('jobgroup/getJobGroup',this.tokenValue);
            },
            searchEvent() {
                localStorage.setItem('edit', JSON.stringify(this.todoFilter));
                this.$f7.views.main.router.navigate('/todo');
            }
        },
        mounted() {
            localStorage.removeItem('edit');
            this.getJobGroup();
        }
    };

</script>